var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9936 0.321045C18.9295 0.321045 18.8653 0.321045 18.7692 0.353127L0.590003 7.28295C0.0770104 7.47545 0.0770104 8.21334 0.622065 8.37376L4.82219 9.81747L7.35509 14.9186C7.38715 15.0148 7.48334 15.079 7.61158 15.079C7.67571 15.079 7.73983 15.0469 7.77189 15.0148L10.1445 12.9936L7.48334 10.9724L7.70777 13.6353L5.78405 9.65706L15.9798 3.5293L7.5154 10.9724L14.1202 15.9773C14.3446 16.1377 14.6011 16.234 14.8576 16.234C15.3706 16.234 15.8836 15.8811 16.0118 15.3357L19.5707 1.05894C19.6669 0.673953 19.3463 0.321045 18.9936 0.321045Z",
    fill: "#00AFE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.900cb7eb43fbfccd41e18661c6e5db6d.svg";
export { ForwardRef as ReactComponent };